const ONE_HOUR_MS = 60 * 60 * 1000;
const HOURS_PER_DAY = 24;

/**
 * Formats the time until a voucher-user assignment expires.
 *
 * This uses the same boundary as svc-promo's eligibility query: an assignment
 * is no longer active once `expired_at <= NOW()`.
 */
/** Formats the live countdown shown in the voucher-user table. */
export function formatVoucherUserTimeRemaining(expiredAt: string | undefined, now = Date.now()): string {
  if (!expiredAt) {
    return 'No expiry';
  }

  const expiresAtMs = new Date(expiredAt).getTime();
  if (!Number.isFinite(expiresAtMs)) {
    return 'Invalid expiry';
  }

  const remainingMs = expiresAtMs - now;
  if (remainingMs <= 0) {
    return 'Expired';
  }

  const remainingHours = Math.floor(remainingMs / ONE_HOUR_MS);
  const days = Math.floor(remainingHours / HOURS_PER_DAY);
  const hours = remainingHours % HOURS_PER_DAY;
  const dayLabel = days === 1 ? 'day' : 'days';
  const hourLabel = hours === 1 ? 'hour' : 'hours';

  return `${days} ${dayLabel} ${hours} ${hourLabel}`;
}
